module.exports = __webpack_public_path__ + "static/media/app.e7f91d68.svg";